import React, { useState, useContext, useEffect, useRef } from "react";
import "./project.scss";
import Card from "../card/card";
import MenuItem from "@mui/material/MenuItem";
import Select1 from "@mui/material/Select";
import { Button, Select } from "antd";
import Input from "@mui/material/Input";
import KeyboardDoubleArrowRight from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeft from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowDown from "@mui/icons-material/KeyboardDoubleArrowDown";
import { Tooltip } from "antd";
import Checkbox from "@mui/material/Checkbox";
import Add from "@mui/icons-material/Add";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import FormatUnderlinedIcon from "@mui/icons-material/FormatUnderlined";
import FormatStrikethroughIcon from "@mui/icons-material/FormatStrikethrough";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import FormatColorText from "@mui/icons-material/FormatColorText";
import Icon from "@mui/material/Icon";
import TextField from "@mui/material/TextField";
import { ProjectContext } from "../../utils/projectContext";
import { BlockPicker } from "react-color";
import textIcon from "../../imgs/text.png";
import assets from "../../imgs/assets.png";
import calibration from "../../imgs/calibration.png";
import { Collapse } from "antd";
import pixelization from "../../imgs/pixelization.png";
import space from "../../imgs/space.png";
import lineheight from "../../imgs/lineheight.png";
import road from "../../imgs/roadIcon.png";
import carInfo from "../../imgs/carInfo.png";
import navigation from "../../imgs/navigation.png";
import warning from "../../imgs/warning.png";
import safety from "../../imgs/safety.png";
import error from "../../imgs/error.png";
import music from "../../imgs/music.png";
import Help from "@mui/icons-material/Help";
import Crop from "@mui/icons-material/Crop";
import Opacity from "@mui/icons-material/Opacity";
import Rotate90DegreesCw from "@mui/icons-material/Rotate90DegreesCw";
import Palette from "@mui/icons-material/Palette";
import FontDownload from "@mui/icons-material/FontDownload";
import TextFields from "@mui/icons-material/TextFields";
import IconLibrary from "../iconLibrary/iconLibrary";
import { Empty, message } from "antd";
import {
  getOssPolicy,
  getIconCategoryList,
  saveIconInfo,
  // getIconList,
  getDuplicateIconList,
  getDuplicateIconCategoryList,
  duplicateIconCategory
} from "../../api/icon";

export default function Project(props) {
  const [selectedItem, setSelectedItem] = useState("");
  const [fontFamily, setfontFamily] = useState("");
  const [fontWeight, setfontWeight] = useState("");
  const [fontSize, setfontSize] = useState("");
  const [fontSpacing, setfontSpacing] = useState("");
  const [lineHeight, setlineHeight] = useState("");
  const [auto, setAuto] = useState(true);
  // const [setVerticalBaseline] = useState('10%');
  // const [setHorizontalBaseline] = useState('10%');
  // const [setBaselineOffset] = useState('0px');
  const [showColor, setShowColor] = useState(false);
  const [fillColor, setFillColor] = useState("#000");
  const pickerRef = useRef(null);
  const { canvasStyle, name } = props.data;
  const [opacity, setopacity] = useState(1);
  const { text, setText } = useContext(ProjectContext);
  const { unactive, setUnactive } = useContext(ProjectContext);
  const { fontStyle, setFontStyle } = useContext(ProjectContext);
  const { fontStyleBtn, setFontStyleBtn } = useContext(ProjectContext);
  const { layerCount, setLayerCount } = useContext(ProjectContext);
  const { layerNow, setLayerNow } = useContext(ProjectContext);
  const { imgs, setImgs } = useContext(ProjectContext);
  const { checkObj, setCheckObj } = useContext(ProjectContext);
  const { showDynamic, setShowDynamic } = useContext(ProjectContext);
  const { dynamic, setDynamic } = useContext(ProjectContext);
  const { cars, setCars } = useContext(ProjectContext);
  const [customName, setCustomName] = useState("");
  const { customTypeName, setCustomTypeName } = useContext(ProjectContext);
  const { newZone, setNewZone } = useContext(ProjectContext);
  const { customTypeNameArr, setCustomTypeNameArr } =
    useContext(ProjectContext);
  const { showData } = useContext(ProjectContext);
  // const [customTypeNameArr, setCustomTypeNameArr] = useState([]);
  const [preCustomTypeName, setPreCustomTypeName] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [height, setHeight] = useState(350);
  const { activeKey, setActiveKey } = useContext(ProjectContext);
  const [cardInfo, setCardInfo] = useState({
    show: false,
    name: "",
    top: 0,
    left: 0,
  });
  const { customFeatures, setCustomFeatures } = useContext(ProjectContext);
  const [zoneName, setZoneName] = useState("");
  const { showZone, setShowZone } = useContext(ProjectContext);
  const [thirdItems, setThirdItems] = useState([]);
  const [secondLayerItems, setSecondLayerItems] = useState([]);
  const { activeSecondKey, setActiveSecondKey } = useContext(ProjectContext);
  const { showFont, setShowFont } = useContext(ProjectContext);
  const { category, setCategory } = useContext(ProjectContext);
  const { iconExclusivity, setIconExclusivity } = useContext(ProjectContext);
  const { showIconExclusive, setShowIconExclusive } =
    useContext(ProjectContext);
  const { imageStyles, setImageStyles } = useContext(ProjectContext);
  const { newCanvas, setNewCanvas } = useContext(ProjectContext);
  const { newCanvasName, setNewCanvasName } = useContext(ProjectContext);
  const [ARActiveKey, setARActiveKey] = useState(["1"]);
  const { setNewApiName } = useContext(ProjectContext);
  const { screenshot, setScreenshot } = useContext(ProjectContext);
  const [isParentEditing, setIsParentEditing] = useState(false);
  const [isChildEditing, setIsChildEditing] = useState(false);
  const [standardLibraryIcon, setStandardLibraryIcon] = useState([]);
  const { classNow, setClassNow } = useContext(ProjectContext);
  const { iconsNow, setIconsNow } = useContext(ProjectContext);
  const { showIcons, setShowIcons } = useContext(ProjectContext);
  const { setDialogOpen } = useContext(ProjectContext);
  const { addOpen, setAddOpen } = useContext(ProjectContext);
  const { selectedIcons, setSelectedIcons } = useContext(ProjectContext);

  let parametersTypes = [
    { label: "speed", value: "speed" },
    { label: "acceleration", value: "acceleration" },
    { label: "directionWheelAngle", value: "directionWheelAngle" },
    {
      label: "distanceFromTheCenterlineOfTheLane",
      value: "distanceToLaneCenter",
    },
  ];
  const [parametersType, setParametersType] = useState(parametersTypes);
  const closeCard = () => {
    setSelectedItem("");
    let active = document.getElementsByClassName("active");
    if (active.length > 0) {
      active[0].classList.remove("active");
    }
    setCardInfo({ ...cardInfo, show: false });
    // setUnactive(true);
  };
  const handleClick = (e) => {
    e.stopPropagation();
  };

  const fetchCopyIcons = async (id) => {
    try {
      const res = await getDuplicateIconList({
        duplicateCategoryId: id,
      })
      if (res.code === 200) {
        setIconsNow(res.data)
      }
    } catch (error) {

    }
  }

  const fetchCopy = async () => {
    try {
      const projectId = localStorage.getItem("projectId");
      if (!projectId) {
        console.warn("项目ID不存在，无法获取图标类副本");
        return;
      }

      const res = await getDuplicateIconCategoryList({
        projectId: Number(projectId),
      });
      
      if (res.code === 200 && res.data) {
        // 找到id与layerCount中layerNow相同的对象中的duplicateIconCategoryId相同的数据
        const now = layerCount.find((layer) => layer.index === layerNow);
        
        if (now && now.duplicateIconCategoryId) {
          const copyIcons = res.data.find(
            (item) => item.id === now.duplicateIconCategoryId
          );
          
          if (copyIcons) {
            setClassNow(copyIcons);
          } else {
            console.warn("未找到对应的图标类副本，ID:", now.duplicateIconCategoryId);
            // 设置默认值，避免 classNow 为空
            setClassNow({
              id: now.duplicateIconCategoryId,
              name: "未知图标类",
              apiInterfaceName: "",
              url: ""
            });
          }
        } else {
          console.warn("当前图层没有 duplicateIconCategoryId");
        }
      } else {
        console.error("获取图标类副本列表失败:", res);
      }
    } catch (error) {
      console.error("获取图标类副本时发生错误:", error);
      // 设置默认值，避免 classNow 为空
      const now = layerCount.find((layer) => layer.index === layerNow);
      if (now && now.duplicateIconCategoryId) {
        setClassNow({
          id: now.duplicateIconCategoryId,
          name: "加载失败",
          apiInterfaceName: "",
          url: ""
        });
      }
    }
  }

  useEffect(() => {
    const now = layerCount.find((layer) => layer.index === layerNow);
    if (now) {
      setCardInfo({
        ...cardInfo,
        name: now.name,
      });
      setShowIconExclusive(true);
      if (now.duplicateIconCategoryId) {
        fetchCopyIcons(now.duplicateIconCategoryId)
        setShowIcons(true);
        fetchCopy();
      } else {
        setShowIcons(false);
      }
    }
  }, [layerNow]);

  useEffect(() => {
    setPreCustomTypeName(customTypeName);
    setShowAlert(false);
  }, [customTypeName]);

  useEffect(() => {
    if (fontStyle) {
      setfontFamily(fontStyle.fontFamily || "");
      setfontWeight(fontStyle.fontWeight || "");
      setfontSize(fontStyle.fontSize || "");
      setfontSpacing(fontStyle.charSpacing || "");
      setlineHeight(fontStyle.lineHeight || "");
      setopacity(fontStyle.opacity);
    }
  }, [fontStyle]);

  const active = (e, index) => {
    const siderItem = e.target.closest(".siderItem");

    if (siderItem && e.target.innerText === "Text Input") {
      e.stopPropagation();
      setText(!text);
      closeCard();
      // console.log(text);

      // siderItem.classList.add("active");
      localStorage.setItem("type", "text");
      setCardInfo({ show: false, left: 0, left: 0 });
    } else {
      // setText(false);
      localStorage.setItem("type", "图片");
      const rect = siderItem.getBoundingClientRect();
      setCardInfo({
        show: true,
        name: items[0].children[index].key,
        top: rect.top,
        left: 20,
      });

      let targetDiv = e.currentTarget;
      let active = document.getElementsByClassName("active");
      if (active.length > 0) {
        active[0].classList.remove("active");
      }
      targetDiv.classList.add("active");
    }
  };

  const navigationActive = (e) => {
    let active = document.getElementsByClassName("navigationActive");
    if (active.length > 0) {
      active[0].classList.remove("navigationActive");
    }
    e.target.classList.add("navigationActive");
  };
  const fontFamilyChange = (e) => {
    // console.log(e);

    setfontFamily(e);
    setFontStyle({ ...fontStyle, fontFamily: e });
  };
  const fontWeightChange = (e) => {
    setfontWeight(e);
    setFontStyle({ ...fontStyle, fontWeight: e });
  };
  const fontSizeChange = (e) => {
    setfontSize(e);
    setFontStyle({ ...fontStyle, fontSize: e });
    if (auto) {
      setlineHeight(1);
      setFontStyle({ ...fontStyle, fontSize: e, lineHeight: 1 });
    }
  };
  const fontSpacingChange = (e) => {
    setfontSpacing(e);
    setFontStyle({ ...fontStyle, charSpacing: e });
  };
  const lineHeightChange = (e) => {
    setlineHeight(e);
    setFontStyle({ ...fontStyle, lineHeight: e });
  };
  const handleCheck = (e) => {
    setAuto(e.target.checked);
    if (e.target.checked) {
      setlineHeight(fontSize);
    }
  };
  const opacityChange = (e) => {
    setopacity(e.target.value);
    setFontStyle({ ...fontStyle, opacity: e.target.value });
  };
  const styleActive = (e, index) => {
    if (fontStyleBtn.includes(index)) {
      let newStyle = fontStyleBtn.filter((item) => item !== index);
      setFontStyleBtn(newStyle);
    } else {
      setFontStyleBtn([...fontStyleBtn, index]);
    }
    if (index === 1) {
      setShowColor(true);
    }
  };
  const toggleVisibility = (e, item) => {
    // e.stopPropagation();
    let newLayer = [...layerCount];
    let index = newLayer.indexOf(item);
    // console.log(newLayer, "newLayer");

    const newVisibility = !newLayer[index].visiable;
    newLayer[index].visiable = newVisibility;

    // 如果是画布,同时隐藏/显示其下的所有功能分区和元素
    if (item.type === "画布" && item.id !== undefined) {
      newLayer = newLayer.map((layer) => {
        // 隐藏/显示所有属于该画布的功能分区和元素
        if (layer.root === item.id) {
          return { ...layer, visiable: newVisibility };
        }
        return layer;
      });
    }
    
    // 如果是功能分区,同时隐藏/显示其下的所有元素
    if (item.type === "功能分区" && item.root !== undefined) {
      newLayer = newLayer.map((layer) => {
        // 隐藏/显示所有属于该功能分区的元素
        if (layer.parent === item.name && layer.root === item.root) {
          return { ...layer, visiable: newVisibility };
        }
        return layer;
      });
    }

    setLayerCount(newLayer);
  };
  const selectLayer = (e, item) => {
    e.stopPropagation();

    if (item.type === "功能分区") {
      setActiveSecondKey([item.index.toString()]);
    } else if (item.type === "画布") {
      setActiveKey([item.index.toString()]);
    }
    setLayerNow(item.index);
    if (item.layerType === "图片") {
      setShowIconExclusive(true);
    } else {
      setShowIconExclusive(false);
    }
  };
  const handleClickOutside = (event) => {
    if (pickerRef.current && !pickerRef.current.contains(event.target)) {
      setShowColor(false);
      setFontStyleBtn(fontStyleBtn.filter((item) => item !== 1));
    }
  };
  const handleChangeComplete = (color, event) => {
    setFillColor(color.hex);
    setFontStyle({ ...fontStyle, fill: color.hex });
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const paramCheck = (item, e) => {
    setCheckObj((prevState) => ({
      ...prevState,
      [item]: e.target.checked,
    }));
  };
  const paramRadioChange = (e) => {
    // console.log(e.target.value);
    // setCars({ carType: designatedVehicle, numberType: e.target.value });
    setCars({ ...cars, numberType: e.target.value });
  };
  const customParam = (e) => {
    // console.log(e.target.value);
    setCustomName(e.target.value);
  };
  const customZone = (e) => {
    setZoneName(e.target.value);
  };
  const addCustom = () => {
    if (!cars.carType) {
      alert("Please enter the specified vehicle");
      return;
    }
    setParametersType([
      ...parametersType,
      { label: customName, value: customName },
    ]);
    setCustomName("");
  };
  const addZone = () => {
    if (zoneName === "") {
      return;
    } else if (customFeatures.find((item) => item.label === zoneName)) {
      alert("The partition name already exists");
    } else {
      setCustomFeatures([
        ...customFeatures,
        { label: zoneName, key: zoneName },
      ]);
      setZoneName("");
      localStorage.setItem(
        "customFeatures",
        JSON.stringify([...customFeatures, { label: zoneName, key: zoneName }])
      );
    }
  };
  const setWhichCar = (e) => {
    // setDesignatedVehicle(e.target.value);
    setCars({ ...cars, carType: e.target.value });
  };
  const customTypeNameChange = (e) => {
    setPreCustomTypeName(e.target.value);
    setShowAlert(true);
  };
  const blurOne = (e) => {
    if (preCustomTypeName === "") {
      return;
    } else {
      let arr = customTypeNameArr;
      if (arr.includes(preCustomTypeName) && showAlert) {
        alert("The custom type name already exists");
        setPreCustomTypeName("");
      } else {
        setCustomTypeNameArr(arr);
        setCustomTypeName(preCustomTypeName);
      }
    }
  };
  const blurCategory = (e) => {
    setCategory(e.target.value);
  };
  const categoryChange = (e) => {
    setCategory(e.target.value);
  };

  const onCollapseChange = (key) => {
    if (key.length > 0 && key[0] === "1") {
      setHeight(350);
    } else {
      setHeight(150);
    }
  };

  const getName = (e) => {
    const siderItem = e.target.closest(".siderItem");

    if (siderItem && e.target.innerText === "Text Input") {
      e.stopPropagation();
      setText(!text);
      closeCard();
      // siderItem.classList.add("active");
      localStorage.setItem("type", "text");
    }
  };

  // const selectFunction = (item) => {
  //   const now = layerCount.find((layer) => layer?.name === item.key);
  //   // console.log(item.label);

  //   if (now) {
  //     setLayerNow(now.index);
  //     setActiveSecondKey(now.index.toString());
  //     setCardInfo({
  //       ...cardInfo,
  //       name: item.label,
  //     });
  //   } else {
  //     setNewZone(item);
  //   }
  //   setShowZone(true);
  //   // console.log(cardInfo);

  // };

  const changeImgStyles = (e, type) => {
    // console.log(e,type, "changeImgStyles");

    setImageStyles({ ...imageStyles, [type]: e.target.value - 0 });
  };

  const imgageCollapseChange = (e) => {
    if (e.some((item) => item === "1")) {
      setCardInfo({
        ...cardInfo,
        show: true,
        top: 328,
        left: 20,
        type: "standard",
      });
    } else if (e.some((item) => item === "2")) {
      setCardInfo({
        ...cardInfo,
        show: true,
        top: 328,
        left: 20,
        type: "custom",
      });
    } else {
      setCardInfo({ ...cardInfo, show: false });
    }
    // console.log(cardInfo);
  };

  const items = [
    {
      key: "1",
      label: "Standard Library",
      style: {
        fontSize: "16px",
        marginLeft: "40px",
      },
    },
    {
      key: "2",
      label: "Upload Icon",
      style: {
        fontSize: "16px",
        marginLeft: "40px",
      },
    },
  ];
  const fontItems = [
    {
      key: "1",
      label: "character",
      style: {
        fontSize: "16px",
      },
      children: (
        <div>
          <div className="fontItemStyle">
            {" "}
            <Select
              id="demo-simple-select-standard"
              defaultValue="宋体"
              style={{ width: 260, marginLeft: 20 }}
              onChange={fontFamilyChange}
              options={[
                { value: "微软雅黑", label: "微软雅黑" },
                { value: "宋体", label: "宋体" },
                { value: "仿宋", label: "仿宋" },
              ]}
            />
            {/* </FormControl> */}
          </div>
          <div className="fontItem">
            <div className="fontItemStyle">
              {" "}
              <Select
                id="demo-simple-select-standard"
                defaultValue="normal"
                style={{ width: 120, marginLeft: 20 }}
                onChange={fontWeightChange}
                options={[
                  { value: "normal", label: "normal" },
                  { value: "bold", label: "bold" },
                  { value: 400, label: "400" },
                  { value: 600, label: "600" },
                  { value: 800, label: "800" },
                ]}
              />
            </div>
            <div>
              <Select
                id="demo-simple-select-standard"
                defaultValue="24px"
                style={{ width: 120, marginLeft: 20 }}
                onChange={fontSizeChange}
                options={[
                  { value: 24, label: "24px" },
                  { value: 26, label: "26px" },
                  { value: 28, label: "28px" },
                  { value: 30, label: "30px" },
                  { value: 32, label: "32px" },
                  { value: 34, label: "34px" },
                ]}
              />
            </div>
          </div>
          <div className="fontItem">
            <div className="space">
              {" "}
              <Select
                className="ant-select-selection"
                defaultValue="1Times"
                style={{ width: 120, marginLeft: 20 }}
                onChange={lineHeightChange}
                options={[
                  { value: 1, label: "1Times" },
                  { value: 2, label: "2Times" },
                  { value: 3, label: "3Times" },
                  { value: 4, label: "4Times" },
                  { value: 5, label: "5Times" },
                  { value: 6, label: "6Times" },
                ]}
              />
              <img src={lineheight} alt="" />
            </div>
            <div className="space">
              <Select
                className="ant-select-selection"
                defaultValue="10em"
                style={{ width: 120, marginLeft: 20 }}
                onChange={fontSpacingChange}
                options={[
                  { value: 10, label: "10em" },
                  { value: 20, label: "20em" },
                  { value: 30, label: "30em" },
                  { value: 40, label: "40em" },
                  { value: 50, label: "50em" },
                ]}
              />
              <img src={space} alt="" />
            </div>
          </div>
          <div className="textStyle">
            {[
              { title: "italic", icon: <FormatItalicIcon /> },
              { title: "Text Color", icon: <FormatColorText /> },
              { title: "underline", icon: <FormatUnderlinedIcon /> },
              { title: "strikethrough", icon: <FormatStrikethroughIcon /> },
            ].map((item, index) => (
              <div
                key={index}
                title={item.title}
                className={`${fontStyleBtn.includes(index) ? "styleActive" : ""
                  }`}
                onClick={(e) => styleActive(e, index)}
                style={{ width: "24px", height: "24px", color: "#fff" }}
              >
                {item.icon}
              </div>
            ))}
            {/* {showColor && (
              <div className="colorPicker" ref={pickerRef}>
                <BlockPicker
                  color={fillColor}
                  onChangeComplete={handleChangeComplete}
                />
              </div>
            )} */}
          </div>
        </div>
      ),
    },
  ];
  const dataItems = [];
  const attributeItems = [
    {
      key: "1",
      label: "attribute",
      style: {
        fontSize: "16px",
      },
      children: (
        <div className="layer">
          <div className="opacity">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                height: 50,
              }}
            >
              <p style={{ color: "#fff" }}>dynamic：</p>
              <Select1
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={dynamic}
                onChange={(e) => setDynamic(e.target.value)}
                style={{
                  width: 100,
                  borderRadius: "5px",
                  border: "1px solid rgba(207, 204, 204, 0.5)",
                  margin: "20px 0 20px 10px",
                  height: 30,
                  color: "#fff",
                }}
              >
                <MenuItem value={true}>yes</MenuItem>
                <MenuItem value={false}>no</MenuItem>
              </Select1>
            </div>
            {showIconExclusive && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  height: 50,
                }}
              >
                <p style={{ color: "#fff" }}>Icon Exclusivity：</p>
                <Select1
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={iconExclusivity}
                  onChange={(e) => setIconExclusivity(e.target.value)}
                  style={{
                    width: 100,
                    borderRadius: "5px",
                    border: "1px solid rgba(207, 204, 204, 0.5)",
                    margin: "20px 0 20px 10px",
                    height: 30,
                    color: "#fff",
                  }}
                >
                  <MenuItem value={true}>yes</MenuItem>
                  <MenuItem value={false}>no</MenuItem>
                </Select1>
              </div>
            )}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 15,
              }}
            >
              <p style={{ width: "30%", color: "#fff" }}>category：</p>
              <TextField
                id="outlined-basic"
                label="Please enter category "
                variant="outlined"
                value={category}
                style={{ backgroundColor: "white", borderRadius: "5px" }}
                onChange={categoryChange}
                onBlur={blurCategory}
                size="small"
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <p style={{ width: "30%", color: "#fff" }}>name：</p>
              <TextField
                id="outlined-basic"
                label="please enter a name"
                variant="outlined"
                value={preCustomTypeName}
                style={{ backgroundColor: "white", borderRadius: "5px" }}
                onChange={customTypeNameChange}
                onBlur={blurOne}
                size="small"
              />
            </div>
          </div>
        </div>
      ),
    },
  ];

  const addNewZone = () => {
    const existingNames = layerCount.map((layer) => layer.name);
    let newName = "功能分区";
    let counter = 1;

    while (existingNames.includes(newName + counter)) {
      counter++;
    }
    const newZoneName = newName + counter;
    setNewZone({
      key: newZoneName,
    });
  };
  const [isGrandchildEditing, setIsGrandchildEditing] = useState(false);
  useEffect(() => {
    // console.log(layerCount, "layerCount");
    const temp = [];
    const parents = layerCount.filter(
      (i) => i.id !== undefined && i.id !== null
    );
    const seconds = layerCount.filter(
      (i) =>
        i.backgroundColor === "#56A5EF" &&
        i.root !== undefined &&
        i.root !== null
    );
    const thirds = layerCount.filter(
      (i) => i.parent !== undefined && i.root !== undefined
    );
    
    // 构建孙节点
    const buildThirds = (parentId, secondName) => {
      return thirds
        .filter((item) => item.root === parentId && item.parent === secondName)
        .map((item, index) => ({
          key: item.index.toString(),
          label: (
            <div
              key={index}
              className={
                fontStyle.index === item.index || layerNow === item.index
                  ? "layerItem activeLayer"
                  : "layerItem"
              }
              onClick={(e) => selectLayer(e, item)}
              style={{
                borderBottom: "1px solid rgba(207, 204, 204, 0.25)",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                onClick={(e) => toggleVisibility(e, item)}
                style={{ color: "#fff" }}
              >
                {item.visiable ? (
                  <VisibilityIcon sx={{ fontSize: 18 }} />
                ) : (
                  <VisibilityOffIcon sx={{ fontSize: 18 }} />
                )}
              </div>
              <div
                className="layerImg"
                style={{
                  color: "#fff",
                }}
              >
                {item.layerType === "text"
                  ? "T"
                  : item.layerType === "数字"
                    ? "N"
                    : item.layerType === "image" || item.layerType === "自定义"
                      ? "I"
                      : ""}
              </div>
              <div style={{ flex: 1 }}>
                {isGrandchildEditing &&
                  layerNow === item.index &&
                  !item.duplicateIconCategoryId ? (
                  <Input
                    defaultValue={item.tempName}
                    onChange={(e) => {
                      const updatedLayerCount = layerCount.map((layer) =>
                        layer.index === item.index
                          ? { ...layer, tempName: e.target.value.trim() }
                          : layer
                      );
                      setLayerCount(updatedLayerCount);
                    }}
                    onBlur={() => {
                      setIsGrandchildEditing(false);
                      
                      if (item.tempName === "") {
                        message.error("名称不能为空");
                        // 恢复原始名称
                        const resetLayerCount = layerCount.map((layer) =>
                          layer.index === item.index
                            ? { ...layer, tempName: item.fileName }
                            : layer
                        );
                        setLayerCount(resetLayerCount);
                        return;
                      }
                      
                      // 名称验证通过，更新名称
                      const updatedLayerCount = layerCount.map((layer) =>
                        layer.index === item.index
                          ? { ...layer, fileName: item.tempName }
                          : layer
                      );
                      setLayerCount(updatedLayerCount);
                    }}
                  />
                ) : (
                  <Tooltip title={item.fileName}>
                    <p
                      style={{ color: "#fff" }}
                      onDoubleClick={() => {
                        if (!item.duplicateIconCategoryId) {
                          setIsGrandchildEditing(true);
                          // 设置临时名称
                          const updatedLayerCount = layerCount.map((layer) =>
                            layer.index === item.index
                              ? { ...layer, tempName: item.fileName }
                              : layer
                          );
                          setLayerCount(updatedLayerCount);
                        }
                      }}
                    >
                      {item.fileName}
                    </p>
                  </Tooltip>
                )}
              </div>
            </div>
          ),
        }));
    };

    // 构建子节点
    const buildSeconds = (parent) => {
      return seconds
        .filter((item) => item.root === parent.id)
        .map((item, index) => ({
          key: item.index.toString(),
          label: (
            <div className="layer">
              <div className="layerItems">
                <div
                  key={index}
                  className={
                    fontStyle.index === item.index || layerNow === item.index
                      ? "layerItem activeLayer"
                      : "layerItem"
                  }
                  onClick={(e) => selectLayer(e, item)}
                  style={{
                    borderBottom: "1px solid rgba(207, 204, 204, 0.25)",
                  }}
                >
                  <div
                    onClick={(e) => toggleVisibility(e, item)}
                    style={{ color: "#fff" }}
                  >
                    {item.visiable ? (
                      <VisibilityIcon sx={{ fontSize: 18 }} />
                    ) : (
                      <VisibilityOffIcon sx={{ fontSize: 18 }} />
                    )}
                  </div>
                  <div
                    className="layerImg"
                    style={{
                      backgroundColor: item.backgroundColor,
                      opacity: item.opacity,
                      color: "#fff",
                    }}
                  ></div>
                  {/* <Tooltip title={item.name}>
                    <p style={{ color: "#fff" }} onDoubleClick={(e) => {
                    e.stopPropagation();
                    const newName = prompt("Enter new name:", item.name);
                    if (newName) {
                      const updatedLayerCount = layerCount.map((layer) =>
                        layer.index === item.index
                          ? { ...layer, name: newName }
                          : layer
                      );
                      const updatedChildren = updatedLayerCount.map((layer) =>
                        layer.parent === item.name
                          ? { ...layer, parent: newName }
                          : layer
                      );
                      setNewCanvasName(newName);
                      setLayerCount(updatedChildren);
                    }
                  }}>{item.name}</p>
                  </Tooltip> */}

                  <div style={{ flex: 1 }}>
                    {isChildEditing &&
                      layerNow === item.index &&
                      item.name !== "功能分区" &&
                      item.name !== "自定义功能分区" ? (
                      <Input
                      defaultValue={item.tempName}
                        onChange={(e) => {
                          const updatedLayerCount = layerCount.map((layer) =>
                            layer.index === item.index
                              ? { ...layer, tempName: e.target.value.trim() }
                              : layer
                          );
                          setLayerCount(updatedLayerCount);
                        }}
                        onBlur={() => {
                          setIsChildEditing(false);
                          
                          // 检查是否有重复的功能分区名称
                          const existingNames = layerCount
                            .filter((layer) => 
                              layer.index !== item.index && 
                              layer.type === "功能分区" &&
                              layer.name === item.tempName
                            );
                          
                          if (existingNames.length > 0) {
                            message.error("名称已存在，请重新命名");
                            // 恢复原始名称
                            const resetLayerCount = layerCount.map((layer) =>
                              layer.index === item.index
                                ? { ...layer, tempName: item.name }
                                : layer
                            );
                            setLayerCount(resetLayerCount);
                            return;
                          }
                          
                          if (item.tempName === "") {
                            message.error("名称不能为空");
                            // 恢复原始名称
                            const resetLayerCount = layerCount.map((layer) =>
                              layer.index === item.index
                                ? { ...layer, tempName: item.name }
                                : layer
                            );
                            setLayerCount(resetLayerCount);
                            return;
                          }
                          
                          // 名称验证通过，更新名称
                          const updatedLayerCount = layerCount.map((layer) =>
                            layer.index === item.index
                              ? { ...layer, name: item.tempName }
                              : layer
                          );
                          const updatedChildren = updatedLayerCount.map(
                            (layer) =>
                              layer.parent === item.name
                                ? { ...layer, parent: item.tempName }
                                : layer
                          );
                          setNewCanvasName(item.tempName);
                          setLayerCount(updatedChildren);
                        }}
                      />
                    ) : (
                      <Tooltip title={item.name}>
                        <p
                          style={{ color: "#fff" }}
                          onDoubleClick={() => setIsChildEditing(true)}
                        >
                          {item.name}
                        </p>
                      </Tooltip>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ),
          children: (
            <div className="layer">
              <div className="layerItems">
                {buildThirds(parent.id, item.name).map((child) => (
                  <React.Fragment key={child.key}>{child.label}</React.Fragment>
                ))}
              </div>
            </div>
          ),
        }));
    };
    // 构建父节点
    const temp2 = parents.map((item, index) => ({
      key: item.index.toString(),
      label: (
        <div className="layer">
          <div className="layerItems">
            <div
              key={index}
              className={
                layerNow === item.index ? "layerItem activeLayer" : "layerItem"
              }
              onClick={(e) => selectLayer(e, item)}
              style={{
                borderBottom: "1px solid rgba(207, 204, 204, 0.25)",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                onClick={(e) => toggleVisibility(e, item)}
                style={{ color: "#fff" }}
              >
                {item.visiable ? (
                  <VisibilityIcon sx={{ fontSize: 18 }} />
                ) : (
                  <VisibilityOffIcon sx={{ fontSize: 18 }} />
                )}
              </div>
              <div
                className="layerImg"
                style={{
                  backgroundColor:
                    item.id !== undefined && item.id !== null
                      ? canvasStyle?.backgroundColor || item?.backgroundColor
                      : "",
                  color: "#fff",
                }}
              >
                {/* {item.layerType === "text"
                  ? "T"
                  : item.layerType === "数字"
                  ? "N"
                  : item.layerType === "image" || item.layerType === "自定义"
                  ? "I"
                  : ""} */}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flex: 1,
                }}
              >
                {/* <p style={{ color: "#fff", flex: 1 }} onDoubleClick={(e) => {
                e.stopPropagation();
                const newName = prompt("Enter new name:", item.name);
                if (newName) {
                  const updatedLayerCount = layerCount.map((layer) =>
                    layer.index === item.index
                      ? { ...layer, name: newName }
                      : layer
                  );
                  setNewCanvasName(newName);
                  setLayerCount(updatedLayerCount);
                }
              }}>{item.name}</p> */}

                {isParentEditing &&
                  layerNow === item.index &&
                  item.name !== "功能分区" &&
                  item.name !== "自定义功能分区" ? (
                  <Input
                  defaultValue={item.name}
                    onChange={(e) => {
                      // 允许输入中文和英文，且输入时不做即时限制
                      const newValue = e.target.value.trim();
                      const updatedLayerCount = layerCount.map((layer) =>
                        layer.index === item.index
                          ? { ...layer, name: newValue }
                          : layer
                      );
                      setLayerCount(updatedLayerCount);
                    }}
                    onBlur={() => {
                      if (item.name === "") {
                        message.error("名称不能为空");
                        // 还原为之前的名称
                        const prevLayer = layerCount.find(layer => layer.index === item.index);
                        const prevName = prevLayer && prevLayer.preName ? prevLayer.preName : "未命名";
                        const updatedLayerCount = layerCount.map((layer) =>
                          layer.index === item.index
                            ? { ...layer, name: prevName }
                            : layer
                        );
                        setLayerCount(updatedLayerCount);
                        setIsParentEditing(false);
                        setNewCanvasName(prevName);
                        return;
                      }
                      // 检查名称是否重复
                      const isDuplicate = layerCount.some(
                        (layer) =>
                          layer.index !== item.index &&
                          layer.name === item.name && layer.type === "画布"
                      );
                      if (isDuplicate) {
                        message.error("名称不能与现有的画布名称重复");
                        // 还原为之前的名称
                        const prevLayer = layerCount.find(layer => layer.index === item.index);
                        const prevName = prevLayer && prevLayer.preName ? prevLayer.preName : "未命名";
                        const updatedLayerCount = layerCount.map((layer) =>
                          layer.index === item.index
                            ? { ...layer, name: prevName }
                            : layer
                        );
                        setLayerCount(updatedLayerCount);
                        setIsParentEditing(false);
                        setNewCanvasName(prevName);
                        return;
                      }
                      setIsParentEditing(false);
                      setNewCanvasName(item.name);
                    }}
                    onFocus={() => {
                      // 记录原始名称，便于还原
                      const updatedLayerCount = layerCount.map((layer) =>
                        layer.index === item.index
                          ? { ...layer, preName: layer.name }
                          : layer
                      );
                      setLayerCount(updatedLayerCount);
                    }}
                    style={{ color: "#fff", flex: 1, width: "100%" }}
                    autoFocus
                  />
                ) : (
                  <Tooltip title={item.name}>
                    <p
                      style={{ color: "#fff", flex: 1 }}
                      onDoubleClick={() => setIsParentEditing(true)}
                    >
                      {item.name}
                    </p>
                  </Tooltip>
                )}

                <Tooltip title="添加功能分区">
                  <Add
                    onClick={() => {
                      addNewZone();
                      setLayerNow(item.index);
                    }}
                  />
                </Tooltip>
              </div>
            </div>
          </div>
        </div>
      ),
      style: {
        fontSize: "16px",
      },
      children: (
        <Collapse
          className="collapse"
          items={buildSeconds(item)}
          ghost
          accordion
          activeKey={activeSecondKey}
          style={{ color: "#fff" }}
          onChange={(key) => {
            setActiveSecondKey(key);
            setLayerNow(parseInt(key[0]));
          }}
        />
      ),
    }));

    setSecondLayerItems(temp2);
  }, [layerCount, isParentEditing, isChildEditing, activeKey]);

  // const secondLayerItems = [
  //   {
  //     key: "1",
  //     label: (
  //       <div className="layer">
  //         <div className="layerItems">
  //           {layerCount
  //             .filter((i) => i.id !== undefined && i.id !== null)
  //             .map((item, index) => (
  //               <div
  //                 key={index}
  //                 className={
  //                   fontStyle.index === item.index || layerNow === item.index
  //                     ? "layerItem activeLayer"
  //                     : "layerItem"
  //                 }
  //                 onClick={(e) => selectLayer(e, item)}
  //                 style={{
  //                   borderBottom: "1px solid rgba(207, 204, 204, 0.25)",
  //                 }}
  //               >
  //                 <div
  //                   onClick={(e) => toggleVisibility(e, item)}
  //                   style={{ color: "#fff" }}
  //                 >
  //                   {item.visiable ? (
  //                     <VisibilityIcon sx={{ fontSize: 18 }} />
  //                   ) : (
  //                     <VisibilityOffIcon sx={{ fontSize: 18 }} />
  //                   )}
  //                 </div>
  //                 <div
  //                   className="layerImg"
  //                   style={{
  //                     backgroundColor:
  //                       item.id !== undefined && item.id !== null
  //                         ? canvasStyle.backgroundColor || item.backgroundColor
  //                         : "",
  //                     color: "#fff",
  //                   }}
  //                 >
  //                   {item.layerType === "文本"
  //                     ? "T"
  //                     : item.layerType === "数字"
  //                     ? "N"
  //                     : item.layerType === "图片" || item.layerType === "自定义"
  //                     ? "I"
  //                     : ""}
  //                 </div>
  //                 <p style={{ color: "#fff",flex:1 }}>{item.name}</p>
  //               </div>
  //             ))}
  //         </div>
  //       </div>
  //     ),
  //     style: {
  //       fontSize: "16px",
  //     },
  //     children: (
  //       <Collapse
  //         className="collapse"
  //         items={thirdItems}
  //         ghost
  //         style={{ color: "#fff" }}
  //         // defaultActiveKey={["1"]}
  //         activeKey={activeSecondKey}
  //         onChange={(key) => setActiveSecondKey(key)}
  //       />
  //     ),
  //   },
  // ];
  const layerItems = [
    {
      key: "1",
      label: "图层",
      style: {
        fontSize: "16px",
      },
      children: (
        <Collapse
          className="collapse secondCollapse"
          items={secondLayerItems}
          ghost
          accordion
          style={{ color: "#fff" }}
          activeKey={activeKey}
          onChange={(key) => setActiveKey(key)}
        />
      ),
    },
  ];
  // const functionItems = [
  //   {
  //     key: "1",
  //     label: "Resident Function",
  //     style: {
  //       fontSize: "16px",
  //       marginLeft: "40px",
  //     },
  //     children: [
  //       { label: "Road Information", key: "道路信息",icon:road },
  //       { label: "Vehicle Information", key: "车辆信息",icon:carInfo },
  //       { label: "Navigation Information", key: "导航信息",icon:navigation },
  //     ].map((item, index) => (
  //       <div
  //         className="functionItem"
  //         key={item.key}
  //         onClick={() => selectFunction(item)}
  //       >
  //         <div className="icon">
  //           <img style={{width:"100%",height:"100%",padding:4}} src={item.icon} alt="" />
  //         </div>
  //         <p style={{ fontSize: "14px" }}>{item.label}</p>
  //         {/* <p className="arrow">&gt;</p> */}
  //       </div>
  //     )),
  //   },
  //   {
  //     key: "2",
  //     label: "Dynamic Function",
  //     style: {
  //       fontSize: "16px",
  //       marginLeft: "40px",
  //     },
  //     children: [
  //       { label: "Warning Message", key: "Warning Message",icon:warning },
  //       { label: "Security Information", key: "Security Information",icon:safety },
  //       { label: "Reminder Information", key: "Reminder Informatio",icon:error },
  //       { label: "Entertainment Information", key: "Entertainment Information",icon:music },
  //     ].map((item, index) => (
  //       <div
  //         className="functionItem"
  //         key={item.key}
  //         onClick={() => selectFunction(item)}
  //       >
  //         <div className="icon">
  //         <img style={{width:"100%",height:"100%",padding:4}} src={item.icon} alt="" />
  //         </div>
  //         <p style={{ fontSize: "14px" }}>{item.label}</p>
  //         {/* <p className="arrow">&gt;</p> */}
  //       </div>
  //     )),
  //   },
  //   {
  //     key: "3",
  //     label: "Custom Features",
  //     style: {
  //       fontSize: "16px",
  //       marginLeft: "40px",
  //     },
  //     children: (
  //       <div>
  //         {customFeatures.map((item, index) => (
  //           <div
  //             className="functionItem"
  //             key={item.key}
  //             onClick={() => selectFunction(item)}
  //           >
  //             <Icon className="icon">list</Icon>
  //             <p style={{ fontSize: "14px" }}>{item.label}</p>
  //             {/* <p className="arrow">&gt;</p> */}
  //           </div>
  //         ))}
  //         <div
  //           style={{
  //             display: "flex",
  //             alignItems: "center",
  //             justifyContent: "center",
  //             marginLeft: -20,
  //           }}
  //         >
  //           <Icon
  //             style={{ marginTop: "15px", cursor: "pointer" }}
  //             onClick={addZone}
  //           >
  //             add
  //           </Icon>
  //           <TextField
  //             id="standard-textarea"
  //             label="Please enter a custom partition name"
  //             placeholder="Customize partition name"
  //             value={zoneName}
  //             variant="standard"
  //             onChange={customZone}
  //           />
  //         </div>
  //       </div>
  //     ),
  //   },
  // ];
  // const positionItems = [
  //   {
  //     key: "1",
  //     label: "Position And Size",
  //     style: {
  //       fontSize: "16px",
  //     },
  //     children: (
  //       <div
  //         style={{
  //           display: "grid",
  //           gridTemplateColumns: "1fr 1fr 1fr",
  //           gap: "10px",
  //           paddingRight: "5px",
  //           color: "#fff",
  //         }}
  //       >
  //         {[
  //           { label: "X", value: imageStyles.left, key: "left" },
  //           { label: "Y", value: imageStyles.top, key: "top" },
  //           { label: "°", value: imageStyles.angle, key: "angle" },
  //           { label: "W", value: imageStyles.width, key: "width" },
  //           { label: "H", value: imageStyles.height, key: "height" },
  //         ].map((item, index) => (
  //           <div
  //             style={{ display: "flex", alignItems: "center" }}
  //             key={item.key}
  //           >
  //             <Input
  //               value={item.value}
  //               style={{ color: "#Fff", paddingLeft: 10 }}
  //               onChange={(e) => changeImgStyles(e, item.key)}
  //             />
  //             {item.label}
  //           </div>
  //         ))}
  //       </div>
  //     ),
  //   },
  // ];
  // const handleCollapseChange = (key) => {
  //   // console.log(key);

  //   if (activeKey.includes(key)) {
  //     setActiveKey(activeKey.filter((item) => item !== key));
  //   } else {
  //     setActiveKey([...activeKey, key]);
  //   }
  // };
  const { showLeftArrow, setShowLeftArrow } = useContext(ProjectContext);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const handleArrowClick = (type) => {
    if (type === "right") {
      setShowRightArrow((prev) => !prev);
      const leftSider = document.querySelector(".leftSider");
      if (leftSider) {
        if (showRightArrow) {
          leftSider.style.transform = "translateX(300px)";
          leftSider.style.transition =
            "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)";
        } else {
          leftSider.style.transform = "translateX(0)";
        }
      }
    } else {
      setShowLeftArrow((prev) => !prev);
      const rightSider = document.querySelector(".rightSider");
      if (rightSider) {
        if (showLeftArrow) {
          rightSider.style.transform = "translateX(-300px)";
          rightSider.style.transition =
            "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)";
        } else {
          rightSider.style.transform = "translateX(0)";
        }
      }
    }
  };

  const ARItems = [
    {
      key: "1",
      label: (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={calibration}
            alt=""
            style={{ width: 30, height: 30, marginRight: 5 }}
          />
          <span style={{ fontSize: "16px", fontWeight: "bold" }}>
            AR-HUD Function
          </span>
          <Tooltip title="勾选后，将在CARLA中为您生成相应功能">
            <Help style={{ width: 16, height: 16, marginLeft: 5 }} />
          </Tooltip>
          <span style={{ marginLeft: "auto", marginRight: 10 }}>
            {ARActiveKey.includes("1") ? (
              <KeyboardDoubleArrowDown />
            ) : (
              <KeyboardDoubleArrowRight />
            )}
          </span>
        </div>
      ),
      showArrow: false,
      style: {
        fontSize: "16px",
      },
      children: (
        <div style={{ marginLeft: 0 }}>
          {[
            {
              label: "实时路线导航",
              key: "实时路线导航",
            },
            {
              label: "标志牌增强显示",
              key: "标志牌增强显示",
            },
            {
              label: "风险物体提示",
              key: "风险物体提示",
            },
            {
              label: "前车风险提示",
              key: "前车风险提示",
            },
          ].map((item, index) => (
            <div key={index} className="checkbox">
              <Checkbox
                sx={{
                  "& .MuiSvgIcon-root": { fontSize: 25 },
                  color: "#fff",
                }}
                onChange={(e) => paramCheck(item.key, e)}
                checked={checkObj[item.key] || false}
              />
              <p style={{ color: "#fff" }}>{item.label}</p>
            </div>
          ))}
        </div>
      ),
    },
  ];

  const ARChange = (key) => {
    setARActiveKey(key);
  };

  const [textActiveKey, setTextActiveKey] = useState(["1"]);
  const [imgActiveKey, setImgActiveKey] = useState(["1"]);
  const [iconLibraryActiveKey, setIconLibraryActiveKey] = useState(["1"]);
  const [localActiveKey, setLocalActiveKey] = useState(["1"]);
  const [openIconLIbrary, setOpenIconLIbrary] = useState(false);
  const [iconActiveKey, setIconActiveKey] = useState(["1"]);
  const textChange = (key) => {
    setTextActiveKey(key);
  };
  const imgChange = (key) => {
    setImgActiveKey(key);
  };
  const iconLibraryChange = (key) => {
    setIconLibraryActiveKey(key);
  };
  const localChange = (key) => {
    setLocalActiveKey(key);
  };
  const iconChange = (key) => {
    setIconActiveKey(key);
  };
  const iconItems = [
    {
      key: "1",
      label: (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            paddingLeft: 0,
            borderBottom: "1px solid #757575",
          }}
        >
          <p style={{ fontSize: "16px", fontWeight: "bold" }}>
            所属图标类:{classNow.name}
          </p>
          <span style={{ marginLeft: "auto", marginRight: 10 }}>
            {iconActiveKey.includes("1") ? (
              <KeyboardDoubleArrowDown />
            ) : (
              <KeyboardDoubleArrowRight />
            )}
          </span>
        </div>
      ),
      style: {
        fontSize: "16px",
      },
      showArrow: false,
      children: (
        <div style={{ color: "#fff" }}>
          {/* <p>API接口名(开发者使用)：test</p> */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: "10px",
              margin: "10px 0",
            }}
          >
            {iconsNow.map((icon, index) => (
              <div
                key={index}
                className="iconItem"
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              onClick={() => {
                // console.log(icon, "icon");
                
                setImgs([icon]);
              }}
              >
                <Tooltip title={`API接口名(开发者使用):${icon.apiInterfaceName}`}>
                 <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
                 <img
                  src={icon.url}
                  alt={icon.name}
                  style={{ width: 35, height: 35 }}
                />
                
                  <p
                    style={{
                      color: "#fff",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      width: 50,
                    }}
                  >
                    {icon.name}
                  </p>
                 </div>
                </Tooltip>
              </div>
            ))}
          </div>
          {/* <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Button
              onClick={() => {
                localStorage.setItem("cardType", "editCopy")
                setDialogOpen(true)
                setSelectedIcons(iconsNow)
              }}
            >
              编辑图标类副本
            </Button>
          </div> */}
        </div>
      ),
    },
  ];
  const iconLibraryItems = [
    {
      key: "1",
      label: (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            paddingLeft: 0,
          }}
        >
          <p style={{ fontSize: "16px", fontWeight: "bold" }}>从图标库中选择</p>
          <span style={{ marginLeft: "auto", marginRight: 10 }}>
            {iconLibraryActiveKey.includes("1") ? (
              <KeyboardDoubleArrowDown />
            ) : (
              <KeyboardDoubleArrowRight />
            )}
          </span>
        </div>
      ),
      style: {
        fontSize: "16px",
      },
      showArrow: false,
      children: (
        <div style={{ textAlign: "right", paddingRight: 5 }}>
          {/* <Empty description={
            <span style={{ color: "#fff" }}>暂无图标</span>
          } image={Empty.PRESENTED_IMAGE_SIMPLE
          }/> */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: "10px",
              marginBottom: 10,
            }}
          >
            {standardLibraryIcon.length > 0 ? (
              standardLibraryIcon.slice(0, 8).map((icon, index) => (
                <div
                  key={index}
                  className="iconItem"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  // onClick={() => {
                  //   setClassNow(icon);
                  // }}
                >
                  <Tooltip title={icon.name}>

                 <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}} onClick={async() => {
                                  setClassNow(icon);
                                  try {
                                   const res = await duplicateIconCategory({
                                      projectId: Number(localStorage.getItem("projectId")),
                                      categoryId: icon.id,
                                    })
                                    if (res.code === 200) {
                                      message.success("图标类副本创建成功");
                                      const rep = await getDuplicateIconList({
                                        duplicateCategoryId : res.data.id,
                                      })
                                      setImgs(rep.data);
                                      setIconsNow(rep.data);
                                    }else{
                                      message.error("图标类副本创建失败");
                                    }
                                  } catch (error) {
                                    console.error("创建图标类副本失败:", error);
                                    message.error("创建图标类副本失败");
                                  }
                                }}>
                 <img
                    src={icon.url}
                    alt={icon.name}
                    style={{ width: 35, height: 35 }}
                  />
                  {/* <p style={{ color: "#fff", textAlign: "center" }}>{icon.name}</p> */}
                    <p
                      style={{
                        color: "#fff",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        width: 50,
                      }}
                    >
                      {icon.name}
                    </p>
                 </div>
                  </Tooltip>
                </div>
              ))
            ) : (
              <Empty
                description={<span style={{ color: "#fff" }}>暂无图标</span>}
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
            )}
          </div>
          <span
            style={{ color: "#fff", cursor: "pointer", fontSize: 14 }}
            onClick={() => {
              localStorage.setItem("cardType", "create")
              setOpenIconLIbrary(true)
            }}
          >
            查看全部
          </span>
        </div>
      ),
    },
  ];
  // const fetchIconList = async (id) => {
  //   const res = await getIconList({ categoryId: Number(id) });
  //   if (res.code === 200) {
  //     setIconsNow(res.data);
  //     setShowIcons(true);
  //   } else {
  //     console.log("获取图标列表失败:", res);
  //   }
  // };
  // useEffect(() => {
  //   if (classNow.id) {
  //     fetchIconList(classNow.id);
  //   }
  // }, [classNow]);
  const uploadImg = async () => {
    const res = await getOssPolicy();
    const ossPolicy = res.data;

    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".png,.jpg,.webp,.jpeg";
    input.style.display = "none";

    input.onchange = async (event) => {
      const file = event.target.files?.[0];
      if (!file) return;
      // console.log(file, "file");
      if (!["image/png", "image/jpeg", "image/webp", "image/jpeg"].includes(file.type)) {
        message.error("只支持上传 PNG、JPG 或 WEBP 格式的图片");
        return;
      }
      const fileKey = `icons/${file.name}`;

      const formData = new FormData();
      formData.append("key", fileKey);
      formData.append("OSSAccessKeyId", ossPolicy.accessid);
      formData.append("policy", ossPolicy.policy);
      formData.append("Signature", ossPolicy.signature);
      formData.append("file", file);

      try {
        const resp = await fetch(ossPolicy.host, {
          method: "POST",
          body: formData,
        });

        if (resp.ok) {
          const fileUrl = `/${fileKey}`;
          console.log("上传成功：", resp);
          setImgs((prevImgs) => [...prevImgs, {url:resp.url+`/${fileKey}`,name:file.name}])
          // const res = await saveIconInfo({
          //   name: file.name,
          //   path: fileUrl,
          //   type: file.type,
          //   size: file.size,
          // });
          // if (res.code === 200) {
          //   const img = res.data;
          //   setImgs((prevImgs) => [...prevImgs, img]);
          // } else {
          //   message.error("图标上传失败，请稍后再试");
          // }
        } else {
          console.error("上传失败", await resp.text());
        }
      } catch (err) {
        console.error("上传异常：", err);
      }
    };

    document.body.appendChild(input);
    input.click();
    document.body.removeChild(input);
  };

  const localItems = [
    {
      key: "1",
      label: (
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <p style={{ fontSize: "16px", fontWeight: "bold" }}>从本地导入 </p>
          <Tooltip title="通过此方式导入的图标不存储在图标库中">
            <Help style={{ width: 16, height: 16, marginLeft: 5 }} />
          </Tooltip>
          <span style={{ marginLeft: "auto", marginRight: 10 }}>
            {localActiveKey.includes("1") ? (
              <KeyboardDoubleArrowDown />
            ) : (
              <KeyboardDoubleArrowRight />
            )}
          </span>
        </div>
      ),
      style: {
        fontSize: "16px",
      },
      showArrow: false,
      children: (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button onClick={uploadImg}>选择文件</Button>
        </div>
      ),
    },
  ];

  const getIconCategorys = async () => {
    try {
      const response = await getIconCategoryList();
      if (response.code === 200) {
        // console.log("图标分类数据:", response.data);
        setStandardLibraryIcon(response.data);
      } else {
        message.error("获取图标分类失败，请稍后再试");
        console.log("获取图标分类失败:", response);
      }
    } catch (error) {
      console.error("Error fetching icon categories:", error);
      message.error("获取图标分类失败，请稍后再试");
    }
  };
  useEffect(() => {
    getIconCategorys();
  }, []);

  const imgItems = [
    {
      key: "1",
      label: (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            borderBottom: "1px solid #757575",
            padding: "10px 0",
          }}
        >
          <img
            src={assets}
            alt=""
            style={{ width: 30, height: 30, marginRight: 5 }}
          />
          <p style={{ fontSize: "16px", fontWeight: "bold" }}>图标</p>
          <span style={{ marginLeft: "auto", marginRight: 10 }}>
            {imgActiveKey.includes("1") ? (
              <KeyboardDoubleArrowDown />
            ) : (
              <KeyboardDoubleArrowRight />
            )}
          </span>
        </div>
      ),
      style: {
        fontSize: "16px",
      },
      showArrow: false,
      children: (
        <div>
          <Collapse
            defaultActiveKey={["1"]}
            onChange={iconLibraryChange}
            items={iconLibraryItems}
            className="collapse"
            ghost
            style={{ color: "#fff" }}
          />
          <Collapse
            defaultActiveKey={["1"]}
            onChange={localChange}
            items={localItems}
            className="collapse"
            ghost
            style={{ color: "#fff" }}
          />
        </div>
      ),
    },
  ];
  const textItems = [
    {
      key: "1",
      label: (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            borderBottom: "1px solid #757575",
            padding: "10px 0",
          }}
        >
          <img
            src={textIcon}
            alt=""
            style={{ width: 30, height: 30, marginRight: 5 }}
          />
          <p style={{ fontSize: "16px", fontWeight: "bold" }}>文本</p>
          <span style={{ marginLeft: "auto", marginRight: 10 }}>
            {textActiveKey.includes("1") ? (
              <KeyboardDoubleArrowDown />
            ) : (
              <KeyboardDoubleArrowRight />
            )}
          </span>
        </div>
      ),
      style: {
        fontSize: "16px",
      },
      showArrow: false,
      children: (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button
            onClick={() => {
              setText(!text);
            }}
          >
            添加文本框
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div>
      {/* right */}
      <div className="leftSider" onClick={getName}>
        {!showRightArrow ? (
          <KeyboardDoubleArrowLeft
            onClick={() => handleArrowClick("right")}
            className="leftArrow"
          />
        ) : (
          <KeyboardDoubleArrowRight
            onClick={() => handleArrowClick("right")}
            className="leftArrow"
          />
        )}
        <div className="content">
          {/* <div
            className="siderItem assets"
            style={{
              padding: `10px 0`,
              borderBottom: "1px solid #737373",
            }}
          >
            <div className="siderItem assets">
              <div className="sideTitle">
                <img src={assets} alt="" />
                <p>Functional Zoning</p>
              </div>
              <Collapse
                className="collapse"
                items={functionItems}
                ghost
                style={{ color: "#fff" }}
                defaultActiveKey={["1", "2"]}
              />
            </div>
          </div> */}

          {layerNow !== null && layerNow !== undefined && (
            
            <div style={{ marginLeft: 16 }}>
              <div>
             {
              showIcons && (
                <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={() => {
                    localStorage.setItem("cardType", "editCopy")
                    setDialogOpen(true)
                    setSelectedIcons(iconsNow)
                    // console.log(iconsNow, "iconsNow in left sider"); // 调试输出
                    
                  }}
                >
                  编辑图标类副本
                </Button>
              </div>
              )
             }
                <p
                  style={{ borderBottom: "1px solid #ccc", padding: "10px 0" }}
                >
                  {(() => {
                    const current = layerCount.find(
                      (item) => item.index === layerNow
                    );
                    if (!current) return "";
                    const type = current.type || "";
                    let displayName = "";
                    if (
                      current.layerType === "text" ||
                      current.layerType === "image"
                    ) {
                      displayName = current.fileName || "";
                    } else {
                      displayName = current.name || "";
                    }
                    return (
                      <Tooltip title={displayName} placement="top">
                        <p>{type}：{displayName}</p>
                      </Tooltip>
                    );
                  })()}
                </p>
              </div>
              <div style={{ margin: "10px 0" }}>
                <div>
                  API接口名(开发者使用)：
                  <Tooltip
                    title={
                      layerCount.find((item) => item.index === layerNow)?.duplicateIconCategoryId ? classNow.apiInterfaceName : layerCount.find((item) => item.index === layerNow)?.apiName
                    }
                    placement="top"
                  >
                    {
                      !layerCount.find((item) => item.index === layerNow)?.duplicateIconCategoryId ? (
                        <Input
                      value={
                        layerCount.find((item) => item.index === layerNow)
                          ?.apiName || ""
                      }
                      style={{ width: 150, color: "#fff", paddingLeft: 10 }}
                      onBlur={(e) => {
                        const newValue = e.target.value;
                        if (newValue === "") {
                          message.error("API名称不能为空");
                          return;
                        }
                        const currentLayer = layerCount.find(
                          (item) => item.index === layerNow
                        );
                        if (currentLayer) {
                          // 获取当前对象所在的画布
                          const currentCanvas = layerCount.find(
                            (item) => item.id === currentLayer.root
                          );
                          
                          // 检查同一画布下是否有重名的API名称
                          const hasDuplicate = layerCount.some(
                            (item) => 
                              item.index !== layerNow && // 不是当前对象
                              item.root === currentLayer.root && // 在同一个画布下
                              item.apiName === newValue // API名称相同
                          );

                          if (hasDuplicate) {
                            message.error("同一画布下API名称不能重复");
                            return;
                          }

                          const updatedLayerCount = layerCount.map((item) =>
                            item.index === layerNow
                              ? { ...item, apiName: newValue }
                              : item
                          );
                          setLayerCount(updatedLayerCount);
                          setNewApiName(newValue);
                        }
                      }}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        if (/^[a-zA-Z0-9]*$/.test(newValue)) {
                          const updatedLayerCount = layerCount.map((item) =>
                            item.index === layerNow
                              ? { ...item, apiName: newValue }
                              : item
                          );
                          setLayerCount(updatedLayerCount);
                        }
                      }}
                      placeholder="Only English letters and numbers"
                    />
                      ):(
                        <span>
                        {classNow.apiInterfaceName}</span>
                      )
                    }
                    
                    {/* <Input
                      value={
                        layerCount.find((item) => item.index === layerNow)
                          ?.apiName || ""
                      }
                      style={{ width: 150, color: "#fff", paddingLeft: 10 }}
                      onBlur={(e) => {
                        const newValue = e.target.value;
                        const currentLayer = layerCount.find(
                          (item) => item.index === layerNow
                        );
                        if (currentLayer && currentLayer.apiName !== newValue) {
                          const updatedLayerCount = layerCount.map((item) =>
                            item.index === layerNow
                              ? { ...item, apiName: newValue }
                              : item
                          );
                          setLayerCount(updatedLayerCount);
                          setNewApiName(newValue);
                        }
                      }}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        if (/^[a-zA-Z0-9]*$/.test(newValue)) {
                          const updatedLayerCount = layerCount.map((item) =>
                            item.index === layerNow
                              ? { ...item, apiName: newValue }
                              : item
                          );
                          setLayerCount(updatedLayerCount);
                        }
                      }}
                      placeholder="Only English letters and numbers"
                    /> */}
                  </Tooltip>
                </div>

                <div style={{ padding: 20 }}>
                  {layerCount.find((item) => item.index === layerNow)?.type ===
                    "画布" && (
                      <div>
                        <div className="fontItemStyleNew">
                          <Palette />
                          <div
                            style={{
                              color: "#fff",
                              margin: "10px 10px",
                              width: 80,
                              height: 28,
                              padding: 5,
                              backgroundColor: "#fff",
                              borderRadius: 5,
                              cursor: "pointer",
                            }}
                            onClick={() => setShowColor(true)}
                          >
                            <div
                              style={{
                                backgroundColor:
                                  layerCount.find(
                                    (item) => item.index === layerNow
                                  )?.backgroundColor || "#fff",
                                width: "100%",
                                height: "100%",
                                borderRadius: 5,
                              }}
                            ></div>
                          </div>
                        </div>
                        {showColor && (
                          <div className="colorPicker" ref={pickerRef}>
                            <BlockPicker
                              color={
                                layerCount.find((item) => item.index === layerNow)
                                  ?.backgroundColor
                              }
                              onChangeComplete={handleChangeComplete}
                            />
                          </div>
                        )}
                      </div>
                    )}
                  {layerCount.find((item) => item.index === layerNow)?.type ===
                    "文本" && (
                      <div>
                        <div className="fontItemStyleNew">
                          <FontDownload />
                          <Select
                            id="demo-simple-select-standard"
                            defaultValue="宋体"
                            style={{
                              width: 100,
                              backgroundColor: "#333",
                              color: "#fff",
                            }}
                            onChange={fontFamilyChange}
                            options={[
                              { value: "微软雅黑", label: "微软雅黑" },
                              { value: "宋体", label: "宋体" },
                              { value: "仿宋", label: "仿宋" },
                            ]}
                          />
                        </div>
                        <div className="fontItemStyleNew">
                          <Palette />
                          <div
                            style={{
                              color: "#fff",
                              margin: "10px 10px",
                              width: 80,
                              height: 28,
                              padding: 5,
                              backgroundColor: "#fff",
                              borderRadius: 5,
                              cursor: "pointer",
                            }}
                            onClick={() => setShowColor(true)}
                          >
                            <div
                              style={{
                                backgroundColor:
                                  layerCount.find(
                                    (item) => item.index === layerNow
                                  )?.color || "#fff",
                                width: "100%",
                                height: "100%",
                                borderRadius: 5,
                              }}
                            ></div>
                          </div>
                        </div>
                        {showColor && (
                          <div className="colorPicker" ref={pickerRef}>
                            <BlockPicker
                              color={fillColor}
                              onChangeComplete={handleChangeComplete}
                            />
                          </div>
                        )}
                      </div>
                    )}

                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "10px",
                      color: "#fff",
                    }}
                  >
                    {[
                      { label: "X", value: imageStyles.left, key: "left" },
                      { label: "Y", value: imageStyles.top, key: "top" },
                      { label: "W", value: imageStyles.width, key: "width" },
                      { label: "H", value: imageStyles.height, key: "height" },
                      {
                        label: "°",
                        value: imageStyles.angle,
                        key: "angle",
                        icon: (
                          <Rotate90DegreesCw
                            style={{ width: 17, height: 17 }}
                          />
                        ),
                      },
                      {
                        label: "%",
                        value: imageStyles.opacity,
                        key: "opacity",
                        icon: <Opacity style={{ width: 17, height: 17 }} />,
                      },
                    ].map((item, index) => (
                      <div
                        style={{ display: "flex", alignItems: "center" }}
                        key={item.key}
                      >
                        {item.icon ? (
                          <>
                            {item.icon}
                            <Input
                              value={item.value}
                              style={{ color: "#Fff", paddingLeft: 20 }}
                              onChange={(e) => changeImgStyles(e, item.key)}
                            />
                            {item.label}
                          </>
                        ) : (
                          <>
                            {item.label}
                            <Input
                              value={item.value}
                              style={{ color: "#Fff", paddingLeft: 20 }}
                              onChange={(e) => changeImgStyles(e, item.key)}
                            />
                          </>
                        )}
                      </div>
                    ))}
                    {layerCount.find((item) => item.index === layerNow)
                      ?.type === "文本" && (
                        <>
                          {" "}
                          <div className="fontItemStyleNew">
                            <img
                              src={space}
                              alt=""
                              style={{ width: 18, height: 18 }}
                            />
                            <Select
                              defaultValue="10em"
                              style={{ width: 100 }}
                              onChange={fontSpacingChange}
                              options={[
                                { value: 10, label: "10em" },
                                { value: 20, label: "20em" },
                                { value: 30, label: "30em" },
                                { value: 40, label: "40em" },
                                { value: 50, label: "50em" },
                              ]}
                            />
                          </div>
                          <div className="fontItemStyleNew">
                            <img
                              src={lineheight}
                              alt=""
                              style={{ width: 18, height: 18 }}
                            />
                            <Select
                              defaultValue="1Times"
                              style={{ width: 100 }}
                              onChange={lineHeightChange}
                              options={[
                                { value: 1, label: "1Times" },
                                { value: 2, label: "2Times" },
                                { value: 3, label: "3Times" },
                                { value: 4, label: "4Times" },
                                { value: 5, label: "5Times" },
                                { value: 6, label: "6Times" },
                              ]}
                            />
                          </div>
                          <div
                            className={`${fontStyleBtn.includes(0)
                                ? "styleActive fontItemStyleNew"
                                : " fontItemStyleNew"
                              }`}
                            style={{
                              justifyContent: "flex-start",
                              cursor: "pointer",
                            }}
                            onClick={(e) => styleActive(e, 0)}
                          >
                            <FormatItalicIcon />
                            <p style={{ marginLeft: 10 }}>斜体</p>
                          </div>
                          <div className="fontItemStyleNew">
                            <TextFields />
                            <Select
                              id="demo-simple-select-standard"
                              defaultValue="24px"
                              style={{ width: 100 }}
                              onChange={fontSizeChange}
                              options={[
                                { value: 24, label: "24px" },
                                { value: 26, label: "26px" },
                                { value: 28, label: "28px" },
                                { value: 30, label: "30px" },
                                { value: 32, label: "32px" },
                                { value: 34, label: "34px" },
                              ]}
                            />
                          </div>
                        </>
                      )}
                  </div>
                </div>
              </div>
            </div>
          )}
          {showZone && (
            <div>
              {/* <div
                className="siderItem"
                onClick={(e) => {
                  if (e.target === e.currentTarget) {
                    getName(e);
                  }
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  borderBottom: "1px solid #737373",
                }}
              >
                <img src={textIcon} alt="" />
                <p>Text Input</p>
              </div> */}
              {!showIcons && (
                <Collapse
                  defaultActiveKey={["1"]}
                  onChange={imgChange}
                  items={imgItems}
                  className="collapse"
                  ghost
                  style={{ color: "#fff" }}
                />
              )}
              <Collapse
                defaultActiveKey={["1"]}
                onChange={textChange}
                items={textItems}
                className="collapse"
                ghost
                style={{ color: "#fff" }}
              />
              {/* <div
                className="siderItem assets"
                style={{
                  padding: `10px 0`,
                  borderBottom: "1px solid #737373",
                }}
              >
                <div className="siderItem assets">
                  <div className="sideTitle">
                    <img src={assets} alt="" />
                    <p>Icon Input</p>
                  </div>
                  <Collapse
                    className="collapse"
                    accordion
                    items={items}
                    ghost
                    style={{ color: "#fff" }}
                    // defaultActiveKey={["1"]}
                    onChange={imgageCollapseChange}
                  />
                </div>
              </div> */}
            </div>
          )}
          {showIcons && layerNow !== null && layerNow !== undefined && (
            <Collapse
              defaultActiveKey={["1"]}
              onChange={iconChange}
              items={iconItems}
              className="collapse"
              ghost
              style={{ color: "#fff" }}
            />
          )}
          {/* <Collapse
            defaultActiveKey={["1"]}
            onChange={ARChange}
            items={ARItems}
            className="collapse"
            ghost
            style={{ color: "#fff" }}
          /> */}

          {/* <div className="siderItem assets">
            <div className="sideTitle">
              <img src={calibration} alt="" />
              <p>AR-HUD Function</p>
              <Tooltip title="勾选后，将在CARLA中为您生成相应功能">
                <Help style={{ width: 16, height: 16, marginLeft: 5 }} />
              </Tooltip>
              <KeyboardDoubleArrowDown style={{marginLeft:"auto",marginRight:10}}/>
            </div>
            <div>
              {[
                {
                  label: "Real-time route navigation",
                  key: "实时路线导航",
                },
                {
                  label: "Enhanced display of signs",
                  key: "标志牌增强显示",
                },
                {
                  label: "Risky object reminder",
                  key: "风险物体提示",
                },
                {
                  label: "Vehicle risk ahead",
                  key: "前车风险提示",
                },
              ].map((item, index) => (
                <div key={index} className="checkbox">
                  <Checkbox
                    sx={{
                      "& .MuiSvgIcon-root": { fontSize: 20 },
                      color: "#fff",
                    }}
                    disabled
                    onChange={(e) => paramCheck(item.key, e)}
                    checked={checkObj[item.key] || false}
                  />
                  <p>{item.label}</p>
                </div>
              ))}
            </div>
          </div> */}
          {/* <div style={{ position: "relative", flex: 1, marginTop: 80 }}>
            <div className="tips">
              <p>*Subsequent Figma plug-ins can quickly import custom elements into "Custom"</p>
              <p>*Technical support:libra@zhilingresearch.com</p>
            </div>
          </div> */}
        </div>
        <div style={{ flex: 1, position: "relative" }}>
          <div style={{ height: 40 }}>
            <div style={{ position: "absolute", bottom: 10, left: 10 }}>
              <Tooltip title="截图">
                <Crop
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (showLeftArrow) {
                      handleArrowClick("left");
                    }
                    if (showRightArrow) {
                      handleArrowClick("right");
                    }
                    setScreenshot(true);
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
      {/* left */}
      <div className="rightSider">
        <div style={{ textAlign: "right" }}>
          {showLeftArrow ? (
            <KeyboardDoubleArrowLeft
              onClick={() => handleArrowClick("left")}
              className="leftArrow"
            />
          ) : (
            <KeyboardDoubleArrowRight
              onClick={() => handleArrowClick("left")}
              className="leftArrow"
            />
          )}
        </div>
        <div className="font" style={{ paddingRight: 30 }}>
          {/* <Collapse
            className="collapse"
            accordion
            items={positionItems}
            ghost
            style={{ color: "#fff" }}
            defaultActiveKey={["1"]}
          /> */}
          {/* {showFont && (
            <Collapse
              className="collapse"
              accordion
              items={fontItems}
              ghost
              style={{ color: "#fff" }}
              defaultActiveKey={["1"]}
            />
          )} */}
          {/* {showData && (
            <Collapse
              className="collapse"
              accordion
              items={dataItems}
              ghost
              style={{ color: "#fff" }}
              onChange={handleCollapseChange}
            />
          )} */}
          {/* {showDynamic && (
            <Collapse
              className="collapse"
              accordion
              items={attributeItems}
              ghost
              style={{ color: "#fff" }}
              onChange={handleCollapseChange}
            />
          )} */}
          <div
            style={{
              position: "relative",
              top: 36,
              right: -200,
              width: 90,
              border: "1px solid #737373",
              borderRadius: 5,
              display: "flex",
              backgroundColor: "#333",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              zIndex: 1000,
            }}
            onClick={() => setNewCanvas(!newCanvas)}
          >
            新建画布
          </div>
          <Collapse
            className="collapse"
            accordion
            items={layerItems}
            ghost
            style={{ color: "#fff", marginBottom: 20 }}
            defaultActiveKey={["1"]}
          />
        </div>
      </div>
      <IconLibrary open={openIconLIbrary} setOpen={setOpenIconLIbrary} />
      {/* {cardInfo.show && (
        <div
          style={{
            position: "absolute",
            top: cardInfo.top,
            left: cardInfo.left,
            zIndex: 1000,
          }}
        >
          <Card
            name={cardInfo.name}
            type={cardInfo.type}
            close={() => closeCard()}
          />
        </div>
      )} */}
    </div>
  );
}
